import Vue from 'vue'
import SweetUI from '@sweet/ui'
import '@sweet/ui-reboot/dist/index.css'
import '@sweet/ui/dist/index.css'
import '@sweet/ui-utils/dist/index.css'

Vue.use(SweetUI)

export default SweetUI
